module.exports = __webpack_public_path__ + "dist/banner_03.02e3da84.png";